import request from "@/utils/request"

export function paramsLast(params) {
  return request.get("/params", {params: params})
}

export function paramsUpdate(data) {
  return request.post("/params/update", data)
}

export function paramsImport(file, type) {
  let formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)
  return request.post("/params/import", formData)
}

export function alarmRules(params) {
  return request.get("/alarmRules", {params: params})
}

export function alarmRuleCreate(data) {
  return request.post("/alarmRules/create", data)
}

export function alarmRuleImport(file, type) {
  let formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)
  return request.post("/alarmRules/import", formData)
}
